import { CommonInput, CrossButton, CustomSelect } from "components";
import React, { useEffect, useState } from "react";
import idfc_bankImg from "../../assets/img/idfc_first_bank2.png";
import checkBal_img from "../../assets/img/ic_check_balance.svg";
import viewTransaction_img from "../../assets/img/ic_view_statement.svg";
import initiateTransaction_img from "../../assets/img/ic_initiate_transaction.svg";
import realTimeData_img from "../../assets/img/ic_realtime_sync.svg";
import transactionHis_img from "../../assets/img/ic_statement_history.svg";
import StorageService from "utils/StorageServices";
import { IoLocationSharp } from "react-icons/io5";
import { registerIdfcAccount } from "_services";
import toast from "react-hot-toast";
import './linkmodal.css';
import { getUserFirm } from "_services/accountsServices/firmServices";
import { Link } from "react-router-dom";
import FirmImg from '../../assets/img/firm.png'


const LinkAccountModal = (props) => {
  let { isOpen, onClose = () => { }, onCloseParent = () => { } } = props;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formError, setFormError] = useState({});
  const [ifscData, setIfscData] = useState(null);
  const [firmDataList, setFirmDataList] = useState([]);
  const firmId = StorageService.getFirmId()


  const [form, setForm] = useState({
    userId: "",
    account_number: "",
    mobileNumber: "",
    account_name: "",
    ifsc: "",
    company_id: StorageService.getCompanyId(),
    firm_id: {}
  });

  const handleChange = async (name, value) => {
    setFormError((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (newErrors[name]) {
        delete newErrors[name];
      }
      return newErrors;
    });

    if (name === "ifsc") {
      checkIfscCode(value);
    }

    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);
  };

  const checkIfscCode = async (value) => {
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${value}`);
      if (response.ok) {
        const data = await response.json();
        setIfscData(data);
      } else {
        throw new Error("Invalid IFSC Code");
      }
    } catch (error) {
      setIfscData(null);
    }
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);

    // Validation
    let errors = {};

    if (!form?.userId?.trim()) {
      errors.userId = "Please enter username";
    }

    if (!form?.account_number?.trim()) {
      errors.account_number = "Please enter account number";
    }

    if (!form?.mobileNumber?.trim()) {
      errors.mobileNumber = "Please enter mobile number";
    }
    if (!form?.account_name?.trim()) {
      errors.account_name = "Please enter account name";
    }
    if (!form?.ifsc?.trim()) {
      errors.ifsc = "Please enter ifsc code";
    }

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      setSubmitLoading(false);
      return;
    }

    const param = {
      ...form,
      firm_id: form?.firm_id?.value,
      mobileNumber: `91${form.mobileNumber}`,
    };

    try {
      const res = await registerIdfcAccount(param);

      if (res?.responseCode === 200) {
        const registration = res?.data?.userRegistrationResp;
        const status = registration?.metaData?.status;

        if (status === "SUCCESS") {
          toast.success(
            registration?.metaData?.message ||
            "Account registered successfully."
          );
          await props.getIdfcAccountList?.();
          onClose?.();
          onCloseParent?.();
        } else {
          // Status is ERROR
          toast.error(
            registration?.metaData?.message || "Registration failed."
          );
        }
      } else {
        toast.error(res?.responseMessage || "Something went wrong.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const getDataFirmList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
      }
      const res = await getUserFirm(object);
      if (res?.responseCode == 200) {
        let apiData = res?.data?.firm_list?.map((el) => {
          return {
            label: el?.firm_id?.firm,
            value: el?.firm_id?._id,
          }
        })
        setFirmDataList(apiData);
        if (!isOpen?._id) {
          if (apiData?.length === 1) {
            setForm((s) => ({
              ...s,
              firm_id: apiData[0]
            }))
          } else {
            setForm((s) => ({
              ...s,
              firm_id: apiData?.find((f) => f?.value == firmId)
            }))
          }
        }
      }
    } catch (error) {
    }
  }

  useEffect(() => {
    getDataFirmList()
  }, [])

  return (
    <>
      <div className="offcanvas-header">
        {/* <h5 className="offcanvas-title">Link your Current Account</h5> */}
        {form?.firm_id?.label ?
          <div>
            <h5 className="offcanvas-title">{"Link your Current Account"}</h5>
            <p className='offcanvas_heading_head'>
              <img src={FirmImg} className='firm_icon_img' /> {" "}
              {form?.firm_id?.label ? form?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
            </p>
          </div>
          :
          <h5 className="offcanvas-title">{" Link your Current Account"}</h5>
        }
        <CrossButton
          type="button"
          className="_switchBtn  __animEffect_btn"
          style={{ marginLeft: "auto" }}
          onClick={() => onClose(!isOpen)}
        >
          <svg
            className="cross"
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
          >
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black"
            />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className="__bnkIntro">
          <div>
            <h4>Awesome !</h4>
            <p>Please fill this form to continue</p>
          </div>
          <img src={idfc_bankImg} alt="IDFC First Bank" />
        </div>

        <div className="__lnkActionBtn_bx">
          <div className="__lnkActBtn">
            <div className="__lnkActIcon">
              <img src={checkBal_img} alt="" />
            </div>
            <p>Check Balance</p>
          </div>

          <div className="__lnkActBtn">
            <div className="__lnkActIcon">
              <img src={viewTransaction_img} alt="" />
            </div>
            <p>View Recent Transaction</p>
          </div>

          <div className="__lnkActBtn">
            <div className="__lnkActIcon">
              <img src={initiateTransaction_img} alt="" />
            </div>
            <p>Initiate Transaction</p>
          </div>

          <div className="__lnkActBtn">
            <div className="__lnkActIcon">
              <img src={realTimeData_img} alt="" />
            </div>
            <p>Realtime Data Sync</p>
          </div>

          <div className="__lnkActBtn">
            <div className="__lnkActIcon">
              <img src={transactionHis_img} alt="" />
            </div>
            <p>Transaction History</p>
          </div>
        </div>

        <div className="__loginDetailBxs">
          <h2>Login Details</h2>

          {firmDataList?.length > 1 && <div className='singleDiv'>
            <CustomSelect
              options={firmDataList}
              label="Select Firm"
              placeholder="Select Firm"
              name="firm_id"
              value={form?.firm_id}
              error={formError["firm_id.label"]}
              // disabled={hideAddNewOption ? false : (formValue?.firm_id?.value ? true : false)}
              onSelect={(data) => handleChange('firm_id', data)}
            />
          </div>}

          <div>
            <CommonInput
              placeholder="Username*"
              label="Username"
              name="userId"
              value={form?.userId}
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
              error={formError?.userId}
            />
          </div>
          <div>
            <CommonInput
              placeholder="Account Name*"
              label="Account Name"
              name="account_name"
              value={form?.account_name}
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
              error={formError?.account_name}
            />
          </div>

          <div>
            <CommonInput
              placeholder="IFSC*"
              label="IFSC"
              name="ifsc"
              value={form?.ifsc}
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
              error={formError?.ifsc}
            />
            {ifscData && (
              <div className="d-flex align-items-center">
                <div>
                  <img
                    src={idfc_bankImg}
                    alt="Bank Logo"
                    width={30}
                    height={30}
                  />
                </div>
                <div className="ml-2">
                  <small>
                    {ifscData?.BANK},{ifscData.BRANCH},{ifscData.CITY}
                  </small>
                </div>
              </div>
            )}
          </div>

          <div>
            <CommonInput
              placeholder="Account Number"
              label="Account Number"
              name="account_number"
              value={form?.account_number}
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
              error={formError?.account_number}
            />
          </div>

          <div>
            <CommonInput
              placeholder="Mobile Number"
              label="Mobile Number"
              name="mobileNumber"
              type="tel"
              value={form?.mobileNumber}
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
              maxLength={10}
              error={formError?.mobileNumber}
            />
          </div>

          <div className="__lnkSubmitBtn_bx">
            {/* <button className='anime-btn __acConnect_btn'>Connect my Account</button> */}
            <button
              className="anime-btn __acConnect_btn"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Connecting..." : "Connect my Account"}
            </button>

            <span>Or</span>
            <button className="anime-btn __acApply_btn">
              Apply for New Account
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LinkAccountModal;
